'use client';

import { createContext, ReactNode, useContext } from 'react';
import { GlobalSettingsDto } from './settings-dto';

const GlobalSettingsContext = createContext<GlobalSettingsDto | null>(null);

export function GlobalSettingsProvider({
  settings,
  children,
}: {
  settings: GlobalSettingsDto;
  children: ReactNode;
}) {
  return <GlobalSettingsContext value={settings}>{children}</GlobalSettingsContext>;
}

export function useGlobalSettings() {
  const settings = useContext(GlobalSettingsContext);

  if (settings === null) {
    throw new Error('No global settings found');
  }

  return settings;
}
